/* src/app/shared/ui-kit/pa-tag-list/pa-tag-list.component.scss */
.pa-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
/*# sourceMappingURL=pa-tag-list.component.css.map */
